/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from "react";
import "components/elements/main/index.scss";

import UserCombinedSearch from "components/widgets/user/UserCombinedSearch";
import UserProductPopularSlider from "components/elements/user/products/UserProductPopularSlider";
import UserProductRecommendedSlider from "components/elements/user/products/UserProductRecommendedSlider";
import UserProductRecommendedViewedSlider from "components/elements/user/products/UserProductRecommendedViewedSlider";
import UserProductTrackAllUsersViewedSlider from "components/elements/user/products/UserProductTrackAllUsersViewedSlider";
import UserProductNewSlider from "components/elements/user/products/UserProductNewSlider";
import UserOffersFavNearbySlider from "components/elements/user/offers/UserOffersFavNearbySlider";
import UserOffersNearbySlider from "components/elements/user/offers/UserOffersNearbySlider";
import UserOffersLatestSlider from "components/elements/user/offers/UserOffersLatestSlider";
import UserShopsNearSlider from "components/elements/user/shops/UserShopsNearSlider";
import UserShopsPopularSlider from "components/elements/user/shops/UserShopsPopularSlider";
import UserShopsLatestSlider from "components/elements/user/shops/UserShopsLatestSlider";
import UserProductCategorySlider from "components/elements/user/products/UserProductCategorySlider";
import UserShopLocationSlider from "components/elements/user/UserShopLocationSlider";
import UserShopsExactLocationSlider from "components/elements/user/shops/UserShopsExactLocationSlider";
import {isFeatureSupported, setLoadCity, getPlatform, isAuthorized, analyticsTrackPageView, analyticsTrackEvent } from "helpers/utils";
import CustomFlexBox from "components/CustomFlexBox";
import { Box } from "@mui/material";
import {Button} from "components/Atoms";
import SlideshowIcon from "@mui/icons-material/Slideshow";
import {useLocation} from "react-router-dom";

const UserHomeMain = (props) => {

    const {
        history
    } = props;

    const urlparams = useLocation();

  const [state, setState] = useState({
    layoutColumns: 3,
  });

  useEffect(() => {

      const loadCity = new URLSearchParams(urlparams.search).get('ct');

      setLoadCity(loadCity);

      analyticsTrackPageView("/", "Main Home");

    document.getElementById("color").setAttribute("href", "#");
  }, []);

    const handleCollectionButtonClick = () => {

        analyticsTrackEvent("User Interaction", "Clicked Latest Collection", "Button Main");

        history.push("/products/sort/popular?ls=1");

    };

  return (
      <div>
          {/* <UserCombinedSearch {...props} colSize={state.layoutColumns} /> */}

          <Box sx={{ mb: 2 }}>
            <UserProductCategorySlider isDirect={true} includeAll={false} {...props} />
          </Box>

          <Box sx={{ mb: 2 }}>
            <UserProductPopularSlider includeHeader={true} />
          </Box>

          <Box sx={{ mb: 2 }}>
              <UserProductNewSlider includeHeader={true} />
          </Box>

          <Box sx={{ mb: 2 }}>
              <UserProductRecommendedViewedSlider includeHeader={true} />
          </Box>

          <Box sx={{ mb: 2 }}>
          <UserProductTrackAllUsersViewedSlider includeHeader={true} />
          </Box>

          {isAuthorized() &&
              <Box sx={{ mb: 2 }}><UserProductRecommendedSlider includeHeader={true} /></Box> }

          {/* <UserShopLocationSlider isDirect={true} isProduct={true} {...props} /> */}

          <Box sx={{ mb: 2 }}>
          <UserShopsPopularSlider includeHeader={true} />
          </Box>

          <Box sx={{ mb: 2 }}>
          <UserShopsLatestSlider includeHeader={true} />
          </Box>

          <Box sx={{ mb: 2 }}>
          <UserShopsNearSlider includeHeader={true} />
          </Box>

          <Box sx={{ mb: 2 }}>
          <UserShopsExactLocationSlider includeHeader={true} />
          </Box>

          {/* <UserShopLocationSlider isDirect={true} isProduct={false} {...props} /> */}

          <Box sx={{ mb: 2 }}>
          <UserOffersNearbySlider includeHeader={true} />
          </Box>


          {isAuthorized() &&
              <Box sx={{ mb: 2 }}><UserOffersFavNearbySlider includeHeader={true} /></Box>}


          <Box sx={{ mb: 2 }}>
          <UserOffersLatestSlider includeHeader={true} />
          </Box>

          {/*isFeatureSupported("shopreels") &&
              <CustomFlexBox sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  position: 'fixed',
                  width: '100%',
                  bottom: 70,
                  justifyContent: 'center',
                  zIndex: 'modal'
              }}>

                      <Button
                          sx={{marginRight: '2px', marginLeft: '4px'}}
                          size="large"
                          color="primary"
                          variant="contained"
                          onClick={() => handleCollectionButtonClick()}
                      >
                          <SlideshowIcon /> &nbsp; Latest Collection
                      </Button>
              </CustomFlexBox>
          */}

      </div>
  );
};

export default UserHomeMain;
